import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { first } from 'lodash';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { VideoJsonLd } from 'next-seo';
import MediaPlayer from '../MediaPlayer';

const useStyles = makeStyles(() => ({
  thumbnail: {
    display: 'flex',
    cursor: 'pointer',
  },
  thumbTitle: {
    fontWeight: 'bold',
    marginLeft: '0.5rem',
    lineHeight: 'normal',
    maxHeight: '2.4em',
    overflow: 'hidden',
    cursor: 'pointer',
  },
  videoView: {
    height: 500,
  },
  videoBox: {
    pointerEvents: 'none',
    cursor: 'pointer',
  },
  mainVideo: {
    '& .MuiSvgIcon-root': {
      transform: 'scale(2)',
    },
  },
}));

const VideoSection = ({ records }) => {
  const classes = useStyles();
  const [activeVideo, setActiveVideo] = useState(first(records));

  useEffect(() => {
    if (get(records, '[0].url')) {
      setActiveVideo(first(records));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [records]);

  return (
    <>
      <div id="video" />
      {records?.map((record, index) => (
        <VideoJsonLd
          {...{
            name: record?.title || '',
            description: record?.description || '',
            contentUrl: record?.url && record?.url,
            embedUrl: record?.url && record?.url,
            thumbnailUrls: [record?.thumbnail?.urls?.small || ''],
            uploadDate: record?.createdAt || '',
          }}
          keyOverride={`VideoStructuredData-${index}`}
        />
      ))}
      <Grid container spacing={4} id="video">
        <Grid item xl={5} md={7} sm={12} xs={12} className={classes.videoView}>
          <MediaPlayer record={activeVideo} className={classes.mainVideo} />
        </Grid>
        <Grid item container xl={4} md={5} sm={12} xs={12} spacing={2} direction="column">
          {records?.map(videoRecord => (
            <Grid item key={videoRecord.id} className={classes.thumbnail} onClick={() => setActiveVideo(videoRecord)}>
              <MediaPlayer
                record={videoRecord}
                type="thumb"
                className={classes.videoBox}
                showPlayButton
                onThumbClick={() => null}
                hidePlay
              />
              <span className={classes.thumbTitle}>{get(videoRecord, 'description')}</span>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </>
  );
};

VideoSection.propTypes = {
  records: PropTypes.array,
};

export default VideoSection;
